import { render, staticRenderFns } from "./BrandDashboard.vue?vue&type=template&id=0b8e01c8&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports